import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import Cart from "../Assest/images/trading/tw1091whm1_1_la.jpg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const colors = [
  { id: 1, value: "#111827" }, // black
  { id: 2, value: "#0f766e" }, // green
  { id: 3, value: "#cbd5e1" }, // light gray
  { id: 4, value: "#dc2626" }, // red
  { id: 5, value: "#2563eb" }, // blue
  { id: 6, value: "#f59e0b" }, // yellow
];
const CartPage = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(2);

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(cart);
  }, []);

  const removeItem = (id) => {
    const updatedCart = cartItems.filter((item) => item._id !== id);
    setCartItems(updatedCart);
    sessionStorage.setItem("cart", JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const increaseQty = (id) => {
    const updatedCart = cartItems.map((item) => {
      if (item._id === id) {
        if (!item.stock) {
          toast.error("Stock not available!");
          return item;
        }

        if (Number(item.qty) >= Number(item.stock)) {
          toast.error("❌ Product Out of Stock!");
          return item;
        }

        return { ...item, qty: Number(item.qty) + 1 };
      }
      return item;
    });

    setCartItems(updatedCart);
    sessionStorage.setItem("cart", JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated")); // ✅ ADD
  };

  const decreaseQty = (id) => {
    const updatedCart = cartItems.map((item) =>
      item._id === id && item.qty > 1 ? { ...item, qty: item.qty - 1 } : item,
    );
    setCartItems(updatedCart);
    sessionStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleProceed = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      // Store current URL for redirect after login
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      navigate("/login");
    } else {
      // Proceed to checkout or next step
      navigate("/checkout"); // Assuming there's a checkout page
    }
  };

  return (
    <>
      <div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>Cart</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">Cart</li>
            </ul>
          </nav>
        </div>
      </div>
      <section className="bg-light py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              {cartItems.length === 0 ? (
                <p>Your cart is empty.</p>
              ) : (
                cartItems.map((item) => (
                  <div key={item._id} className="cart-box">
                    <div className="cart-semi-box">
                      <div className="cart-media">
                        <img
                          className="w-100"
                          src={item.image}
                          alt={item.name}
                        />
                      </div>
                      <div className="cart-details">
                        <h2 className="relate">{item.name}</h2>
                        <div className="d-flex align-items-center mt-3">
                          <h6 className="mb-0 cate-title">
                            <b>Price:</b>
                          </h6>
                          <p className="mb-0 mt-0">₹{item.price}</p>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                          <p className="mb-0 mt-0 call-text">Quantity:</p>
                          <h6 className="mb-0 cate-title text-danger">
                            <b>{item.qty}</b>
                          </h6>
                        </div>
                        <div className="color-wrapper mt-3">
                          <p className="color-title">Color</p>
                          <div className="color-options">
                            {colors.map((color) => (
                              <div
                                key={color.id}
                                className={`color-circle ${
                                  selected === color.id ? "active" : ""
                                }`}
                                onClick={() => setSelected(color.id)}
                              >
                                <span
                                  className="inner-circle"
                                  style={{ backgroundColor: color.value }}
                                ></span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cart-wrapper">
                      <div className="qty-box">
                        <button onClick={() => decreaseQty(item._id)}>−</button>
                        <span className="qty">{item.qty}</span>
                        <button onClick={() => increaseQty(item._id)}>+</button>
                      </div>
                      <button
                        className="add-cart-btn"
                        onClick={() => removeItem(item._id)}
                      >
                        Remove The Item
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>

            {cartItems.length > 0 && (
              <div className="col-lg-4">
                <div className="price-details-card">
                  <h3 className="price-title">PRICE DETAILS</h3>

                  <ul className="price-list">
                    <li>
                      <span>Price ({cartItems.length} items)</span>
                      <span>
                        ₹
                        {cartItems.reduce(
                          (total, item) =>
                            total + Number(item.price) * Number(item.qty),
                          0,
                        )}
                      </span>
                    </li>

                    <li className="discount">
                      <span>Discount</span>
                      <span>- ₹0</span>
                    </li>

                    <li className="discount">
                      <span>Buy more & save more</span>
                      <span>- ₹0</span>
                    </li>

                    <li className="discount">
                      <span>Coupons for you</span>
                      <span>- ₹0</span>
                    </li>

                    <li>
                      <span>Protect Promise Fee</span>
                      <span>₹0</span>
                    </li>
                  </ul>

                  <div className="price-total">
                    <span>Total Amount</span>
                    <span>
                      ₹
                      {cartItems.reduce(
                        (total, item) => total + item.price * item.qty,
                        0,
                      )}
                    </span>
                  </div>

                  <p className="price-saved">You will save ₹0 on this order</p>
                  <button
                    className="add-cart-btn bg-primary1"
                    onClick={handleProceed}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        closeOnClick
        pauseOnHover
      />
    </>
  );
};

export default CartPage;
